//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/Builder.js";
let d=[[[0,"Associative",1,0],[0,"CopyGroups",1,0],[0,"CopyThreads",1,0],[0,"DisplayReferenceGeometry",1,0],[0,"InheritDisplayProperties",1,0],[0,"InheritMaterial",1,0],[0,"MakePositionIndependent",1,0],[0,"SourcePartOccurrence",1,"TaggedObject",0]],[[[],"SetALL",{},0,0],[[],"ClearAll",{},0,0],[["selectedObjects"],"InsertObjects",{},1,0],[["removedObjects"],"RemoveObjects",{},1,0]],[]];
SPLM.Features.WaveInterfaceLinkerBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.WaveInterfaceLinkerBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;